import React, { useEffect } from "react";
import _ from "lodash";

import { useController, Controller } from "react-hook-form";
import ConvertStringToHtml from "../ConvertStringToHtml";

export const RadioInputField = React.forwardRef((props, ref) => {
  const { field, fieldState } = useController(props);
  const {
    spaceX,
    title,
    style,
    type,
    errors,
    defaultValue,
    disabled = false,
    showLabel = true,
    isInLineTitle = false,
    titleCustomStyle = " ",
    labelClass = "",
    unCheck = false,
    uncheckRadio,
    customClass = "",
    inSameRow = true,
    capitalize = true,
    id_key= 'key',
    ...others
  } = props;
  const checkArr = typeof props.data[0];
  let err = _.get(errors, props.name);

  useEffect(() => {
    // Update the field value when the value prop from the parent changes
    if (props?.enableUpdate) {
      field.onChange(props.value);
    }
  }, [props.value]);

  return (
    <div
      className={`${
        isInLineTitle && "flex items-center gap-x-5"
      } ${customClass}`}
    >
      <p
        className={`text-md mb-1  ${
          props?.rules && err ? "text-red-600" : "text-gray-600"
        } ${titleCustomStyle}`}
      >
        {/* {title}  */}
        <ConvertStringToHtml msg={title} />
      </p>
      <Controller
        name={props?.name}
        control={props?.control}
        rules={props?.rules}
        defaultValue={defaultValue}
        render={({ field: { onChange, value } }) => {
          return (
            <>
              <div
                className={`${inSameRow && "flex"} items-center flex-wrap md:flex-nowrap gap-x-${
                  spaceX ? spaceX : "2"
                }`}
              >
                {props.data?.map((v, k) => (
                  <>
                    <label
                      className={`flex items-center space-x-2 cursor-pointer ${labelClass}`}
                    >
                      <input
                        {...field}
                        checked={
                          checkArr == "object" ? v[id_key] === value : v === value
                        }
                        value={checkArr == "object" ? v[id_key] : v}
                        key={checkArr == "object" ? v[id_key] : v}
                        type="radio"
                        onClick={(e) => {
                          if (unCheck) {
                            if (e.target.value == field.value) {
                              props?.setValue(props?.name, "");
                              if (uncheckRadio) {
                                uncheckRadio();
                              }
                              if (props.onChange) {
                                //for changing the state of parent component if this method is using
                                props.onChange(e, props?.name, "");
                              }
                            }
                          }
                          if (props.onClick) {
                            props.onClick(
                              e,
                              props?.name,
                              v,
                              e.target.value == field.value
                            );
                          }
                        }}
                        onChange={(e) => {
                          onChange(e.target.value);
                          if (props.onChange) {
                            props.onChange(e, props?.name, v);
                          }
                        }}
                        disabled={disabled ? disabled : false}
                        // {...others}
                      />
                      <span
                        className={`text-md ${capitalize ? 'capitalize' : 'text-base' } border-transparent focus:ring-transparent focus:border-transparent focus:ring-0 focus:outline-none ${
                          props?.rules && err
                            ? "text-red-600"
                            : style
                            ? style
                            : "text-gray-600"
                        }`}
                      >
                        {(showLabel && (v?.label || v?.title || v?.replaceAll("_", " "))) ||
                          ""}
                      </span>
                    </label>
                  </>
                ))}
              </div>
            </>
          );
        }}
      />
    </div>
  );
});
